import { useField } from 'formik';
import React from 'react';

import { FormFieldError } from '../FormFields/FieldError';
import { FieldInput } from '../FormFields/FieldInput';

type FormikTextInputProps = {
  label: React.ReactElement | string;
  isRequired?: boolean;
  children?: React.ReactElement;
};

export const FormikPasswordInput = ({ label, isRequired, children, ...props }: FormikTextInputProps & any) => {
  const [field, meta] = useField(props);

  return (
    <div className='flex flex-col my-2'>
      <label
        data-testid={`label-for-${field.name}`}
        className='mb-2 text-sm font-bold text-dark-gray'
        htmlFor={props.id || props.name}
      >
        {label}
        {isRequired && <span className='px-1'>*</span>}
      </label>
      <FieldInput type='password' field={field} meta={meta} {...props}>
        {children}
      </FieldInput>
      <FormFieldError field={field} meta={meta} />
    </div>
  );
};
